"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgZoomMinusOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M14.605 13.194l7 6.998a1 1 0 01-1.414 1.414h-.001l-6.997-7a7 7 0 111.412-1.412zM9 14A5 5 0 109 4a5 5 0 000 10zM7 8h4c.667-.001 1 .332 1 1 0 .668-.333 1.001-1 1H7c-.667 0-1-.334-1-1.002 0-.668.333-1 1-.998z' }))); };
exports.default = SvgZoomMinusOutline;
//# sourceMappingURL=ZoomMinusOutline.js.map